(() => {

const $3015960e114022d6$export$8ee1df3c6367a60 = '0.7.0';
const $3015960e114022d6$export$ce10f0e840983122 = {
    WIDTH: 4000,
    HEIGHT: 3000
};
const $3015960e114022d6$export$9ccab9b526ccfd1e = {
    'XS': 2.5,
    'S': 5,
    'M': 10,
    'L': 20,
    'XL': 40
};
const $3015960e114022d6$export$a037d132965e1c9f = {
    ONE: 1,
    TEN: 10,
    HUNDRED: 100 // mt
};
const $3015960e114022d6$export$98ff4de2f070152d = {
    // VIEW
    PAN: "PAN",
    ZOOM: "ZOOM",
    SELECT: "SELECT",
    DELETE: "DELETE",
    // EDIT
    MOVE: 'MOVE',
    ROTATE: "ROTATE",
    COPY: 'COPY',
    RESIZE: "RESIZE",
    // SHAPES
    LINE: 'LINE',
    RECT: 'RECT',
    CIRCLE: 'CIRCLE',
    ARC: 'ARC',
    // STYLE
    FILL: 'FILL',
    // UTILS
    TEXT: 'TEXT',
    MEASURES: 'MEASURES'
};
const $3015960e114022d6$export$95a0ad41b3bb8285 = [
    // NAVY
    // SILVER
    '#DDDDDD'
];
const $3015960e114022d6$export$56d196d2844d1ca1 = {
    grey: {
        shapes_fill_temp: '#E8E9E9',
        shapes_fill_selected: 'rgb(200,0,100,0.25)',
        shapes_stroke: 'white',
        shapes_stroke_selected: 'salmon',
        LINES: 'grey',
        CURSOR: 'orange',
        CANVAS: "rgb(31,40,49)",
        LINES_BIG: "rgb(48,55,71)",
        LINES_SMALL: "rgb(36,45,56)"
    },
    blue: {
        shapes_fill_temp: '#E8E9E9',
        shapes_fill_selected: 'rgba(200,0,100,0.25)',
        shapes_stroke: '#D1D3D4',
        shapes_stroke_selected: 'salmon',
        LINES: 'white',
        CURSOR: '#ad7fa8',
        CANVAS: "#0f223e",
        LINES_BIG: "rgb(48,55,71)",
        LINES_SMALL: "rgb(36,45,56)"
    },
    white: {
        shapes_fill_temp: '#D1D3D4',
        shapes_fill_selected: 'rgba(231,76,60,0.25)',
        shapes_stroke: 'black',
        shapes_stroke_selected: 'salmon',
        LINES: 'black',
        CURSOR: '#2ecc71',
        CANVAS: "rgb(235,242,250)",
        LINES_BIG: "#D1D3D4",
        LINES_SMALL: "#E8E9E9"
    }
};
const $3015960e114022d6$export$d597759d33be802e = {
    OFFSET: 5,
    FONT: '13px Arial'
};
const $3015960e114022d6$export$a8fef325e42f6db3 = {
    TIME: 1,
    STEP: .05
};


class $eb41710cff79e6ba$export$2e2bcd8739ae039 {
    constructor(main){
        this.main = main;
        // DEFAULTS
        this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).SELECT;
        this.currentSnap = (0, $3015960e114022d6$export$9ccab9b526ccfd1e).M;
        this.hasSnap = true;
        this.startListenDocumentKeyup();
        document.body.addEventListener('CMD-PANEL', (passed)=>{
            this.choosenCommand = passed.detail;
        }, false);
    }
    startListenDocumentKeyup() {
        document.onkeyup = (e)=>{
            // track keyboard events only if the text input modal is not open
            if (!this.main.textModal.isOpen) {
                if (e.key == 'Escape' || e.key == 's') {
                    this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).SELECT;
                    this.main.shapes.forEach((e)=>{
                        e.selected = false;
                    });
                    this.main.selected = null;
                /* 
                } else if (e.key == 'a') {
                    this.choosenCommand = OPERATIONS.ARC;*/ } else if (e.key == 'w') this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).ROTATE;
                else if (e.key == 'f') this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).MEASURES;
                else if (e.key == 'e') this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).RESIZE;
                else if (e.key == 'c') this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).COPY;
                else if (e.key == 'm') this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).MOVE;
                else if (e.key == 'd') this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).DELETE;
                else if (e.key == 'l') this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).LINE;
                else if (e.key == 'r') this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).RECT;
                else if (e.key == 'a') this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).CIRCLE;
                else if (e.key == 'p') this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).PAN;
                else if (e.key == 't') this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).TEXT;
                else if (e.key == 0) {
                    this.hasSnap = false;
                    this.sendCustomEvent('CMD-SNAP', '0');
                } else if (e.key == "1") {
                    this.hasSnap = true;
                    this.currentSnap = (0, $3015960e114022d6$export$9ccab9b526ccfd1e).XL;
                    this.sendCustomEvent('CMD-SNAP', '1');
                } else if (e.key == "2") {
                    this.hasSnap = true;
                    this.currentSnap = (0, $3015960e114022d6$export$9ccab9b526ccfd1e).L;
                    this.sendCustomEvent('CMD-SNAP', '2');
                } else if (e.key == "3") {
                    this.hasSnap = true;
                    this.currentSnap = (0, $3015960e114022d6$export$9ccab9b526ccfd1e).M;
                    this.sendCustomEvent('CMD-SNAP', '3');
                } else if (e.key == "4") {
                    this.hasSnap = true;
                    this.currentSnap = (0, $3015960e114022d6$export$9ccab9b526ccfd1e).S;
                    this.sendCustomEvent('CMD-SNAP', '4');
                } else if (e.key == "5") {
                    this.hasSnap = true;
                    this.currentSnap = (0, $3015960e114022d6$export$9ccab9b526ccfd1e).XS;
                    this.sendCustomEvent('CMD-SNAP', '5');
                } else if (e.ctrlKey && e.key == 'z') this.main.HM.undo();
                else if (e.ctrlKey && e.key == 'y') this.main.HM.redo();
                else if (e.ctrlKey && e.key == 'x') this.main.zoomLevel = 1;
                else if (e.altKey && e.key == '+') this.main.zoomLevel += 0.1;
                else if (e.altKey && e.key == '-') this.main.zoomLevel -= 0.1;
                else if (e.key == 'x') this.choosenCommand = (0, $3015960e114022d6$export$98ff4de2f070152d).ZOOM;
            }
            this.sendCustomEvent('CMD-KEYS', this.choosenCommand);
        };
    }
    sendCustomEvent(key, payload) {
        const event = new CustomEvent(key, {
            bubbles: true,
            detail: payload
        });
        document.body.dispatchEvent(event);
    }
}


class $24da230c0903dec3$export$2e2bcd8739ae039 {
    constructor(main){
        this.main = main;
        this.history = [
            []
        ];
        this.position = 0;
    }
    get value() {
        return this.history[this.position];
    }
    get selected() {
        return this.history[this.position].find((e)=>e.selected)[0];
    }
    set(value) {
        if (this.position < this.history.length - 1) this.history = this.history.slice(0, this.position + 1);
        this.history.push([
            ...value
        ]);
        this.position += 1;
    }
    undo() {
        if (this.position > 0) {
            this.position--;
            this.main.shapes = [
                ...this.value
            ];
        } else console.log('No more undo ...');
    }
    redo() {
        if (this.position < this.history.length - 1) {
            this.position++;
            this.main.shapes = [
                ...this.value
            ];
        } else console.log('No more redo ...');
    }
    clean() {
        this.history = [
            []
        ];
        this.position = 0;
    }
    // toString function to aid in illustrating
    toString() {
        console.log("Currnent Value: ", this.value);
        console.log("History: ", this.history);
        console.log("Position: ", this.position);
    }
}


const $cfe5df418f7b3b1a$export$44b25ebaae13a246 = {};
function $cfe5df418f7b3b1a$export$c961cccdf4099cd8(shape) {
    const r = Math.round(Math.random() * 255);
    const g = Math.round(Math.random() * 255);
    const b = Math.round(Math.random() * 255);
    let key = `rgb(${r},${g},${b})`;
    shape.colorKey = key;
    if (!(key in $cfe5df418f7b3b1a$export$44b25ebaae13a246)) $cfe5df418f7b3b1a$export$44b25ebaae13a246[key] = shape;
    return shape;
}
function $cfe5df418f7b3b1a$export$89e29e4ab65e70a9(a = {
    x: 0,
    y: 0
}, b = {
    x: 0,
    y: 0
}, frac) {
    var nx = a.x + (b.x - a.x) * frac;
    var ny = a.y + (b.y - a.y) * frac;
    return {
        x: nx,
        y: ny
    };
}
function $cfe5df418f7b3b1a$export$3ae94a2503e890a1(date) {
    var d = new Date(date), month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [
        year,
        month,
        day
    ].join('-');
}
function $cfe5df418f7b3b1a$export$848d71df1f759bc(h) {
    let r = 0, g = 0, b = 0;
    // 3 digits
    if (h.length == 4) {
        r = "0x" + h[1] + h[1];
        g = "0x" + h[2] + h[2];
        b = "0x" + h[3] + h[3];
    // 6 digits
    } else if (h.length == 7) {
        r = "0x" + h[1] + h[2];
        g = "0x" + h[3] + h[4];
        b = "0x" + h[5] + h[6];
    }
    return `rgba(${+r},${+g},${+b},.3)`;
}
const $cfe5df418f7b3b1a$export$e4a39213ddb1b05a = 'https://fastcnc-react-master.vercel.app';
const $cfe5df418f7b3b1a$export$e0588e7b8006558e = 'https://flusk-backend.onrender.com';
const $cfe5df418f7b3b1a$export$bb3b75778e3e272 = async (filename)=>{
    try {
        const response = await fetch(`${$cfe5df418f7b3b1a$export$e0588e7b8006558e}/api/download/${filename}`);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }
        // Create a blob from the response
        const blob = await response.blob();
        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        // Trigger download
        document.body.appendChild(a);
        a.click();
        // Cleanup
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        return true;
    } catch (error) {
        console.error('Download failed:', error);
        alert(`Download failed: ${error.message}`);
        return false;
    }
};
const $cfe5df418f7b3b1a$export$f659963672546679 = (filename)=>{
    const s3Url = `https://fastcnc.s3.eu-central-1.amazonaws.com/uploads/calc/${filename}`;
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = s3Url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};




class $97e92fc7315ed4d9$export$2e2bcd8739ae039 {
    constructor(app){
        this.main = app;
        this.x = this.x || 0;
        this.y = this.y || 0;
        this.newX = this.newX || 0;
        this.newY = this.newY || 0;
        this.panel = document.querySelector('#panel');
        this.header = document.querySelector('#panel-header');
        this.colors = document.querySelector('.colors');
        this.fillBtn = document.querySelector('.right');
        this.slider = document.querySelector('.slider');
        this.generateColors();
        this.choosenCommand = 'SELECT'; // default
        this.adjustSelection();
        this.adjustColorSelection(this.main.selectedColorInPanel);
        // EVENTS
        this.header.onmousedown = this.dragMouseDown.bind(this);
        this.panel.onclick = this.click.bind(this);
        // EVENTS from USER KEYBOARDS
        document.body.addEventListener('CMD-KEYS', (passed)=>{
            console.log(`Event from keyboard: ${passed.detail}`);
            this.choosenCommand = passed.detail;
            this.adjustSelection();
        }, true);
        // EVENTS from USER KEYBOARDS for SNAP
        document.body.addEventListener('CMD-SNAP', (passed)=>{
            console.log(`Event from keyboard: ${passed.detail}`);
            this.slider.value = passed.detail;
        }, true);
        // EVENTS from USER SELECTION
        document.body.addEventListener('SELECT-ITEM', (passed)=>{
            console.log(`Selected element: ${passed.detail}`);
            if (passed.detail || passed.detail == 0) {
                this.main.selectedColorInPanel = this.main.shapes[passed.detail].color;
                this.adjustColorSelection(this.main.selectedColorInPanel);
            }
        }, true);
        this.slider.addEventListener('input', (e)=>{
            switch(e.target.value){
                case '0':
                    this.main.keys.hasSnap = false;
                    break;
                case '1':
                    this.main.keys.hasSnap = true;
                    this.main.keys.currentSnap = (0, $3015960e114022d6$export$9ccab9b526ccfd1e).XL;
                    break;
                case '2':
                    this.main.keys.hasSnap = true;
                    this.main.keys.currentSnap = (0, $3015960e114022d6$export$9ccab9b526ccfd1e).L;
                    break;
                case '3':
                    this.main.keys.hasSnap = true;
                    this.main.keys.currentSnap = (0, $3015960e114022d6$export$9ccab9b526ccfd1e).M;
                    break;
                case '4':
                    this.main.keys.hasSnap = true;
                    this.main.keys.currentSnap = (0, $3015960e114022d6$export$9ccab9b526ccfd1e).S;
                    break;
                case '5':
                    this.main.keys.hasSnap = true;
                    this.main.keys.currentSnap = (0, $3015960e114022d6$export$9ccab9b526ccfd1e).XS;
                    break;
                default:
                    this.main.keys.hasSnap = true;
                    this.main.keys.currentSnap = (0, $3015960e114022d6$export$9ccab9b526ccfd1e).M;
                    break;
            }
        }, false);
    }
    // http://clrs.cc/
    generateColors() {
        let li = (0, $3015960e114022d6$export$95a0ad41b3bb8285);
        this.colors.innerHTML = '<ul>' + li.map((e)=>`<li class="color-dot" data-color="${e}" style="background-color:${e}"></li>`).join('') + '</ul>';
        this.colors.addEventListener('click', this.selectColor.bind(this));
    }
    selectColor(evt) {
        let c = evt.target.dataset.color;
        this.main.selectedColorInPanel = c;
        this.adjustColorSelection(c);
    }
    adjustColorSelection(c) {
        let items = this.colors.getElementsByTagName("li");
        for(let i = 0; i < items.length; ++i){
            items[i].classList.remove('selected-color');
            if (items[i].dataset.color === c) items[i].classList.add('selected-color');
        }
        if (this.main.selected || this.main.selected == 0) this.main.shapes[this.main.selected].color = this.main.selectedColorInPanel;
    }
    adjustSelection() {
        let all = this.panel.querySelectorAll('.cmd');
        for(let i = 0; i < all.length; i++){
            const element = all[i];
            if (element.dataset.cmd === this.choosenCommand) element.classList.add('selected');
            else element.classList.remove('selected');
        }
    }
    click(e) {
        console.log(`Event from commands panel: ${e.target.dataset.cmd}`);
        this.choosenCommand = e.target.parentNode.dataset.cmd;
        if (this.choosenCommand) {
            if (this.choosenCommand === 'UNDO') {
                this.main.HM.undo();
                return;
            }
            if (this.choosenCommand === 'REDO') {
                this.main.HM.redo();
                return;
            }
            if (this.choosenCommand === 'FILL') {
                this.fillBtn.classList.toggle('hide');
                return;
            }
            if (this.choosenCommand === 'CONFIG') {
                this.switchUnitSystem();
                return;
            }
            if (this.choosenCommand === 'SAVE') {
                this.save();
                return;
            }
            if (this.choosenCommand === 'IMPORT') {
                this.import();
                return;
            }
            if (this.choosenCommand === 'HELP') {
                window.open("https://github.com/LorenzoCorbella74/my-web-cad");
                return;
            }
            if (this.choosenCommand === 'PALETTE') {
                this.switchTheme();
                return;
            }
            if (!e.target.classList.contains('disabled')) {
                const event = new CustomEvent('CMD-PANEL', {
                    bubbles: true,
                    detail: this.choosenCommand
                });
                this.panel.dispatchEvent(event);
                this.adjustSelection();
            }
        }
    }
    switchUnitSystem() {
        let options = Object.keys((0, $3015960e114022d6$export$a037d132965e1c9f));
        let index = options.findIndex((e)=>e === this.main.choosenUnitSystem);
        if (index < options.length - 1) index++;
        else index = 0;
        this.main.choosenUnitSystem = options[index];
    }
    switchTheme() {
        let options = [
            'grey',
            'white',
            'blue'
        ];
        let index = options.findIndex((e)=>e === this.main.selectedTheme);
        if (index < options.length - 1) index++;
        else index = 0;
        this.main.selectedTheme = options[index];
    }
    dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        this.newX = e.clientX;
        this.newY = e.clientY;
        this.panel.onmouseup = this.closeDragElement.bind(this);
        // call a function whenever the cursor moves:
        this.panel.onmousemove = this.elementDrag.bind(this);
    }
    elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        this.x = this.newX - e.clientX;
        this.y = this.newY - e.clientY;
        this.newX = e.clientX;
        this.newY = e.clientY;
        // set the element's new position:
        this.panel.style.top = this.panel.offsetTop - this.y + "px";
        this.panel.style.left = this.panel.offsetLeft - this.x + "px";
    }
    closeDragElement() {
        /* stop moving when mouse button is released:*/ this.panel.onmouseup = null;
        this.panel.onmousemove = null;
    }
    import() {
        let input = document.getElementById('file-input');
        input.onchange = (e)=>{
            // getting a hold of the file reference
            var file = e.target.files[0];
            // setting up the reader
            var reader = new FileReader();
            reader.readAsText(file, 'UTF-8');
            // here we tell the reader what to do when it's done reading...
            reader.onload = (readerEvent)=>{
                var content = readerEvent.target.result; // this is the content!
                try {
                    this.createDrawingFromImportedFile(JSON.parse(content));
                } catch (error) {
                    console.log('Was not possible to import the file!');
                }
            };
        };
        input.click();
    }
    save() {
        let output = {
            ver: (0, $3015960e114022d6$export$8ee1df3c6367a60),
            date: (0, $cfe5df418f7b3b1a$export$3ae94a2503e890a1)(new Date()),
            shapes: this.main.HM.value,
            theme: this.main.selectedTheme
        };
        if (!output.shapes || output.shapes.length === 0) {
            alert("Empty Design: Please add some shapes before saving.");
            return;
        }
        let dxfContent = '0\nSECTION\n2\nHEADER\n0\nENDSEC\n';
        dxfContent += '0\nSECTION\n2\nTABLES\n0\nENDSEC\n';
        dxfContent += '0\nSECTION\n2\nBLOCKS\n0\nENDSEC\n';
        dxfContent += '0\nSECTION\n2\nENTITIES\n';
        output.shapes.forEach((shape)=>{
            if (shape.start_x !== undefined && shape.start_y !== undefined && shape.end_x !== undefined && shape.end_y !== undefined) {
                // Line
                dxfContent += `0\nLINE\n8\n0\n10\n${shape.start_x}\n20\n${shape.start_y}\n30\n0.0\n`;
                dxfContent += `11\n${shape.end_x}\n21\n${shape.end_y}\n31\n0.0\n`;
            } else if (shape.radius !== undefined) {
                // Circle
                dxfContent += `0\nCIRCLE\n8\n0\n10\n${shape.start_x}\n20\n${shape.start_y}\n30\n0.0\n`;
                dxfContent += `40\n${shape.radius}\n`;
            } else if (shape.measure !== undefined) {
                // Text (annotation)
                dxfContent += `0\nTEXT\n8\n0\n10\n${shape.start_x}\n20\n${shape.start_y}\n30\n0.0\n`;
                dxfContent += `40\n${shape.font}\n1\n${shape.measure}\n`;
            }
        });
        dxfContent += '0\nENDSEC\n0\nSECTION\n2\nOBJECTS\n0\nENDSEC\n0\nEOF\n';
        // upload the DXF in server . 
        const blob = new Blob([
            dxfContent
        ], {
            type: 'application/dxf'
        });
        const formData = new FormData();
        formData.append('file', blob, `drawing_${(0, $cfe5df418f7b3b1a$export$3ae94a2503e890a1)(new Date())}.dxf`);
        // Replace with your actual API endpoint
        const API_URL = `${(0, $cfe5df418f7b3b1a$export$e0588e7b8006558e)}/calc/upload_dxf_ref`;
        fetch(API_URL, {
            method: 'POST',
            body: formData
        }).then((response)=>response.json()).then((data)=>{
            console.log('File uploaded successfully:', data);
            if (data.success && data.file_path) {
                const encodedFilePath = encodeURIComponent(data.file_path);
                const opened_url = `${(0, $cfe5df418f7b3b1a$export$e4a39213ddb1b05a)}?file=${encodedFilePath}`;
                // console.log("url is >", opened_url)
                window.open(opened_url, '_blank');
            }
        }).catch((error)=>{
            console.error('Error uploading file:', error);
        });
    }
    createDrawingFromImportedFile(data) {
        this.main.selectedTheme = data.theme;
        this.main.HM.clean();
        this.main.shapes = data.shapes;
        this.main.HM.set(this.main.shapes);
    }
}


class $da30683a9f099617$export$2e2bcd8739ae039 {
    constructor(app){
        this.main = app;
        // Get the modal
        this.modal = document.getElementById("myModal");
        this.content = this.modal.querySelector(".modal-content");
        this.input = this.modal.querySelector(".modal-content input");
        // Get the <span> element that closes the modal
        this.closeBtn = document.getElementsByClassName("close")[0];
        this.saveBtn = document.getElementsByClassName("save")[0];
        this.closeBtn.addEventListener('click', this.close.bind(this));
        this.saveBtn.addEventListener('click', this.save.bind(this));
        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function(event) {
            if (event.target == this.modal /* && this.isOpen */ ) this.close(event);
        };
    }
    close(e) {
        this.modal.style.display = "none";
        this.isOpen = false;
    }
    save(e) {
        this.close();
        this.callback && this.callback({
            x: this.x,
            y: this.y,
            val: this.input.value
        });
        this.input.value = '';
    }
    open(x, y, value, callback) {
        this.isOpen = true;
        this.x = x;
        this.y = y;
        this.modal.style.display = "block";
        this.content.style.position = "absolute";
        this.content.style.left = x + 'px';
        this.content.style.top = y - 26 + 'px';
        this.input.value = value;
        this.input.focus();
        this.callback = callback;
    }
}





function $34a88fa094de8ae4$export$f0a6c66fc4a3a14a(scope) {
    scope.ctx.strokeStyle = (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].CURSOR; // green
    scope.ctx.strokeRect(scope.mouse.x - 5 - scope.netPanningX, scope.mouse.y - 5 - scope.netPanningY, 10, 10);
    scope.ctx.lineWidth = 0.5;
    scope.ctx.setLineDash([
        scope.keys.currentSnap,
        scope.keys.currentSnap
    ]); // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/setLineDash
    scope.ctx.beginPath();
    scope.ctx.moveTo(scope.mouse.x - scope.netPanningX, 0);
    scope.ctx.lineTo(scope.mouse.x - scope.netPanningX, scope.mouse.y - 5 - scope.netPanningY);
    scope.ctx.moveTo(scope.mouse.x - scope.netPanningX, scope.mouse.y + 5 - scope.netPanningY);
    scope.ctx.lineTo(scope.mouse.x - scope.netPanningX, (0, $3015960e114022d6$export$ce10f0e840983122).HEIGHT);
    scope.ctx.moveTo(0, scope.mouse.y - scope.netPanningY);
    scope.ctx.lineTo(scope.mouse.x - 5 - scope.netPanningX, scope.mouse.y - scope.netPanningY);
    scope.ctx.moveTo(scope.mouse.x + 5 - scope.netPanningX, scope.mouse.y - scope.netPanningY);
    scope.ctx.lineTo((0, $3015960e114022d6$export$ce10f0e840983122).WIDTH, scope.mouse.y - scope.netPanningY);
    scope.ctx.stroke();
    scope.ctx.fillStyle = (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].LINES;
    scope.ctx.fillText(`${scope.keys.choosenCommand.toUpperCase()}`, scope.mouse.x + 12.5 - scope.netPanningX, scope.mouse.y - 4.5 - scope.netPanningY);
    scope.ctx.fillText(`x: ${scope.getValueAccordingToUnitSystem(scope.mouse.x - scope.netPanningX)} - y: ${scope.getValueAccordingToUnitSystem(scope.mouse.y - scope.netPanningY)}`, scope.mouse.x + 12.5 - scope.netPanningX, scope.mouse.y + 12.5 - scope.netPanningY);
    scope.ctx.fillText(`${scope.info.key} ${scope.getValueAccordingToUnitSystem(scope.info.value1)} ${scope.getValueAccordingToUnitSystem(scope.info.value2)}`, scope.mouse.x + 12.5 - scope.netPanningX, scope.mouse.y + 27.5 - scope.netPanningY);
    scope.ctx.closePath();
    scope.ctx.setLineDash([]);
}
function $34a88fa094de8ae4$export$9556ac62448d043c(scope) {
    scope.ctx.fillStyle = (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].CANVAS;
    scope.ctx.fillRect(0, 0, (0, $3015960e114022d6$export$ce10f0e840983122).WIDTH, (0, $3015960e114022d6$export$ce10f0e840983122).HEIGHT);
    // colonne
    for(let i = 0; i < (0, $3015960e114022d6$export$ce10f0e840983122).WIDTH; i += scope.keys.currentSnap){
        if (scope.keys.hasSnap) {
            scope.ctx.beginPath();
            scope.ctx.moveTo(i + 0.5, 0);
            scope.ctx.lineTo(i + 0.5, (0, $3015960e114022d6$export$ce10f0e840983122).HEIGHT);
            if (i % 100 === 0) scope.ctx.strokeStyle = (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].LINES_BIG;
            else scope.ctx.strokeStyle = (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].LINES_SMALL;
            scope.ctx.lineWidth = 0.5;
            scope.ctx.closePath();
            scope.ctx.stroke();
        }
        if (i % 100 === 0) {
            scope.ctx.font = (0, $3015960e114022d6$export$d597759d33be802e).FONT;
            scope.ctx.fillStyle = (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].LINES;
            // scope.ctx.textAlign = "center";
            scope.ctx.fillText(scope.getValueAccordingToUnitSystem(i).toString(), i + 2.5, 10 - (scope.netPanningY > 0 ? 0 : scope.netPanningY));
        }
    }
    // righe
    for(let i = 0; i < (0, $3015960e114022d6$export$ce10f0e840983122).HEIGHT; i += scope.keys.currentSnap){
        if (scope.keys.hasSnap) {
            scope.ctx.beginPath();
            scope.ctx.moveTo(0, i + 0.5);
            scope.ctx.lineTo((0, $3015960e114022d6$export$ce10f0e840983122).WIDTH, i + 0.5);
            if (i % 100 === 0) scope.ctx.strokeStyle = (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].LINES_BIG;
            else scope.ctx.strokeStyle = (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].LINES_SMALL;
            scope.ctx.lineWidth = 0.5;
            scope.ctx.closePath();
            scope.ctx.stroke();
        }
        if (i % 100 === 0) {
            scope.ctx.font = (0, $3015960e114022d6$export$d597759d33be802e).FONT;
            scope.ctx.fillStyle = (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].LINES;
            // scope.ctx.textAlign = "center";
            scope.ctx.fillText(scope.getValueAccordingToUnitSystem(i).toString(), 2.5 - (scope.netPanningX > 0 ? 0 : scope.netPanningX), i - 2.5);
        }
    }
}
function $34a88fa094de8ae4$export$8a2d2490727d6d12(scope, ctx, hit) {
    [
        ...scope.HM.value,
        ...scope.tempShape
    ].forEach((item)=>{
        if (hit) ctx.lineWidth = 10 // to select lines or sides of rect...
        ;
        else ctx.lineWidth = 0.5;
        if (item.text || item.measure) {
            if (hit) {
                ctx.save();
                ctx.fillStyle = item.colorKey;
                ctx.beginPath();
                let textLength = ctx.measureText(item.text).width;
                // console.log(textLength, 9 * item.text.length) /* 9px for each char */
                ctx.rect(item.start_x - textLength / 2, item.start_y - 13, textLength, 20);
                ctx.fill();
                ctx.stroke();
                ctx.restore();
            } else {
                ctx.save();
                ctx.fillStyle = item.selected ? (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].shapes_fill_selected : hit ? item.colorKey : item.color;
                ctx.beginPath();
                ctx.font = item.font;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                if (item.text) ctx.fillText(item.text, item.start_x, item.start_y);
                else if (item.measure) ctx.fillText(scope.getValueAccordingToUnitSystem(item.measure).toString(), item.start_x, item.start_y);
                ctx.restore();
            }
        } else if (item.w && item.h) {
            ctx.save();
            ctx.fillStyle = item.selected ? (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].shapes_fill_selected : hit ? item.colorKey : (0, $cfe5df418f7b3b1a$export$848d71df1f759bc)(item.color);
            ctx.strokeStyle = item.selected ? (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].shapes_stroke_selected : hit ? item.colorKey : item.stroke;
            ctx.beginPath();
            ctx.translate(item.start_x + item.w / 2, item.start_y + item.h / 2);
            if (item.angle) ctx.rotate(item.angle);
            ctx.rect(-item.w / 2, -item.h / 2, item.w, item.h);
            ctx.fill();
            ctx.stroke();
            ctx.restore();
        } else if (item.radius) {
            ctx.save();
            ctx.strokeStyle = item.selected ? (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].shapes_stroke_selected : hit ? item.colorKey : item.stroke;
            ctx.fillStyle = item.selected ? (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].shapes_fill_selected : hit ? item.colorKey : (0, $cfe5df418f7b3b1a$export$848d71df1f759bc)(item.color);
            ctx.beginPath();
            // x, y, radius, startAngle, endAngle, antiClockwise = false by default
            ctx.arc(item.start_x, item.start_y, item.radius, 0, 2 * Math.PI, false) // full circle
            ;
            ctx.fill();
            ctx.stroke();
            ctx.restore();
        } else $34a88fa094de8ae4$var$drawLine(scope, ctx, item, hit);
    });
}
function $34a88fa094de8ae4$var$drawLine(scope, ctx, item, hit) {
    let aWidth = 5, aLength = 8;
    ctx.setLineDash([
        0,
        0
    ]);
    let dx = item.end_x - item.start_x;
    let dy = item.end_y - item.start_y;
    let angle = Math.atan2(dy, dx);
    let length = Math.sqrt(dx * dx + dy * dy);
    ctx.strokeStyle = item.selected ? (0, $3015960e114022d6$export$56d196d2844d1ca1)[scope.selectedTheme].shapes_stroke_selected : hit ? item.colorKey : item.stroke;
    ctx.translate(item.start_x, item.start_y);
    ctx.rotate(angle);
    ctx.beginPath();
    if (item.dashed) ctx.setLineDash([
        3.5,
        10
    ]);
    ctx.moveTo(0, 0);
    ctx.lineTo(length, 0);
    if (!hit && item.arrowStart) {
        ctx.moveTo(aLength, -aWidth);
        ctx.lineTo(0, 0);
        ctx.lineTo(aLength, aWidth);
    }
    if (!hit && item.arrowEnd) {
        ctx.moveTo(length - aLength, -aWidth);
        ctx.lineTo(length, 0);
        ctx.lineTo(length - aLength, aWidth);
    }
    ctx.stroke();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
}


class $5dbb7e23012fa79b$export$2e2bcd8739ae039 {
    constructor(main){
        // ref to main class istance
        this.main = main;
    }
    mousemove(e) {
        this.main.mouse.x = e._x;
        this.main.mouse.y = e._y;
        this.main.mouse.event = e;
    }
    mousedown(e) {
    // console.log('Command: mousedown', e, this)
    }
    mouseup(event) {
    // console.log('Command: mouseup', event, this)
    }
    mouseout(event) {
        this.mouseup(event);
    }
    click(event) {
    // console.log('Command: click', event, this)
    }
}



class $1bf019947b3489fd$export$2e2bcd8739ae039 extends (0, $5dbb7e23012fa79b$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
        // this.mouse drag related variables
        this.isMouseDown = false;
        this.startX, this.startY;
        // the accumulated horizontal(X) & vertical(Y) panning the user has done in total
        this.main.netPanningX = 0;
        this.main.netPanningY = 0;
    }
    limitCamera(panx, pany) {
        let a, b;
        if (panx < 0) a = Math.max(-(0, $3015960e114022d6$export$ce10f0e840983122).WIDTH, panx);
        else a = 0;
        if (pany < 0) b = Math.max(-(0, $3015960e114022d6$export$ce10f0e840983122).HEIGHT, pany);
        else b = 0;
        return {
            a: a,
            b: b
        };
    }
    mousemove(e) {
        let x = e._x;
        let y = e._y;
        // if the this.mouse is being dragged
        if (this.isMouseDown) {
            // dx & dy are the distance the this.mouse has moved since the last this.mousemove event
            var dx = x - this.startX;
            var dy = y - this.startY;
            // reset the vars for next this.mousemove
            this.startX = x;
            this.startY = y;
            // accumulate the net panning done
            this.main.netPanningX += dx;
            this.main.netPanningY += dy;
            let { a: a, b: b } = this.limitCamera(this.main.netPanningX, this.main.netPanningY);
            this.main.netPanningX = a;
            this.main.netPanningY = b;
        // console.clear()
        // console.log(`Net change in panning: x:${this.main.netPanningX}px, y:${this.main.netPanningY}px`);
        }
        this.main.mouse.x = e._x;
        this.main.mouse.y = e._y;
        this.main.mouse.event = e;
    }
    mousedown(e) {
        // calc the starting this.mouse X,Y for the drag
        this.startX = e._x;
        this.startY = e._y;
        // set the isDragging flag
        this.isMouseDown = true;
    }
    mouseup(e) {
        // clear the isDragging flag
        this.isMouseDown = false;
    }
}



class $02795c1fd5893706$export$2e2bcd8739ae039 extends (0, $5dbb7e23012fa79b$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
        this.mouseDown = false;
    }
    mousemove(e) {
        // console.log('Zoom: mousemove', e, this)
        this.main.mouse.x = e._x;
        this.main.mouse.y = e._y;
        this.main.mouse.event = e;
        if (this.mouseDown) {
            if (!e.ctrlKey) this.main.zoomLevel += .005;
            else this.main.zoomLevel -= .005;
        }
    }
    mousedown(e) {
        // console.log('Zoom: mousedown', e, this)
        this.mouseDown = true;
    }
    mouseup(event) {
        // console.log('Zoom: mouseup', event, this)
        this.mouseDown = false;
    }
}





class $228d9af8d0930561$export$2e2bcd8739ae039 extends (0, $5dbb7e23012fa79b$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
    }
    click(e) {
        // get pixel under cursor
        const pixel = this.main.gctx.getImageData(e._x * this.main.zoomLevel, e._y * this.main.zoomLevel, 1, 1).data;
        // create rgb color for that pixel
        const color = `rgb(${pixel[0]},${pixel[1]},${pixel[2]})`;
        // find a shape with the same colour
        this.main.shapes.forEach((item, index)=>{
            if (item.colorKey === color) {
                item.selected = true;
                this.main.selected = index;
                const event = new CustomEvent('SELECT-ITEM', {
                    bubbles: true,
                    detail: this.main.selected
                });
                document.body.dispatchEvent(event);
            } else item.selected = false;
        });
        if (this.main.shapes.every((e)=>e.selected === false)) this.main.selected = null;
        // if it's a text open the dialogue
        if (this.main.shapes[this.main.selected] && this.main.shapes[this.main.selected].text) {
            let theOne = this.main.shapes[this.main.selected];
            this.main.textModal.open(theOne.start_x - this.main.netPanningX, theOne.start_y - this.main.netPanningY, theOne.text, (val)=>this.updateText(val));
        }
    }
    updateText(info) {
        let { val: val } = info;
        this.main.shapes[this.main.selected].text = val;
        this.main.HM.set(this.main.shapes);
    }
}



class $65d7843234b90f5f$export$2e2bcd8739ae039 extends (0, $5dbb7e23012fa79b$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
    }
    click(e) {
        const pixel = this.main.gctx.getImageData(e._x * this.main.zoomLevel, e._y * this.main.zoomLevel, 1, 1).data;
        // create rgb color for that pixel
        const color = `rgb(${pixel[0]},${pixel[1]},${pixel[2]})`;
        // remove the shape with the same colour
        let found = 0;
        for(var i = this.main.shapes.length - 1; i >= 0; i--)if (this.main.shapes[i].colorKey === color) {
            this.main.shapes.splice(i, 1);
            found++;
        }
        if (found) this.main.HM.set(this.main.shapes);
    }
}





class $c168e99c8e60108e$export$2e2bcd8739ae039 extends (0, $5dbb7e23012fa79b$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
        this.started = false;
        this.start = {};
    }
    mousemove(event) {
        this.main.mouse.x = event._x;
        this.main.mouse.y = event._y;
        this.main.mouse.event = event;
        if (this.started) {
            this.main.tempShape = [
                {
                    start_x: this.start.x,
                    start_y: this.start.y,
                    end_x: event._x - this.main.netPanningX,
                    end_y: event._y - this.main.netPanningY,
                    stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].LINES
                }
            ];
            let dx = this.start.x - (event._x - this.main.netPanningX);
            let dy = this.start.y - (event._y - this.main.netPanningY);
            this.main.info = {
                key: 'Dist: ',
                value1: Math.floor(Math.sqrt(dx * dx + dy * dy))
            };
        }
    }
    mousedown(event) {
        this.start.x = event._x - this.main.netPanningX;
        this.start.y = event._y - this.main.netPanningY;
        this.started = true;
    }
    mouseup(event) {
        if (this.started) {
            this.started = false;
            this.main.tempShape.length = 0;
            this.main.shapes.push((0, $cfe5df418f7b3b1a$export$c961cccdf4099cd8)({
                start_x: this.start.x,
                start_y: this.start.y,
                end_x: this.start.x,
                end_y: this.start.y,
                final_end_x: event._x - this.main.netPanningX,
                final_end_y: event._y - this.main.netPanningY,
                animationCreate: true,
                counterCreate: 0,
                stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].shapes_stroke
            }));
            this.main.HM.set(this.main.shapes);
            this.main.info = {
                key: '',
                value1: '',
                value2: ''
            };
        }
    }
}





class $4b31ddf9131026d9$export$2e2bcd8739ae039 extends (0, $5dbb7e23012fa79b$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
        this.started = false;
        this.start = {};
        this.x, this.y;
        this.width, this.height;
    }
    mousemove(event) {
        this.main.mouse.x = event._x;
        this.main.mouse.y = event._y;
        this.main.mouse.event = event;
        if (this.started) {
            this.x = Math.min(event._x, this.start.x), this.y = Math.min(event._y, this.start.y), this.w = Math.abs(event._x - this.start.x), this.h = Math.abs(event._y - this.start.y);
            if (!this.w || !this.h) return;
            this.main.tempShape = [
                {
                    start_x: this.x - this.main.netPanningX,
                    start_y: this.y - this.main.netPanningY,
                    w: this.w,
                    h: this.h,
                    color: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].shapes_fill_temp
                }
            ];
            this.main.info = `W: ${this.w}, H: ${this.h}`;
            this.main.info = {
                key: 'W x H: ',
                value1: this.w,
                value2: this.h
            };
        }
    }
    mousedown(event) {
        this.start.x = event._x;
        this.start.y = event._y;
        this.started = true;
    }
    mouseup(event) {
        if (this.started) {
            this.started = false;
            this.main.tempShape.length = 0;
            this.main.shapes.push((0, $cfe5df418f7b3b1a$export$c961cccdf4099cd8)({
                start_x: this.x - this.main.netPanningX,
                start_y: this.y - this.main.netPanningY,
                final_w: this.w,
                final_h: this.h,
                w: 0,
                h: 0,
                angle: 0,
                animationCreate: true,
                counterCreate: 0,
                color: this.main.selectedColorInPanel,
                stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].shapes_stroke
            }));
            this.main.HM.set(this.main.shapes);
            this.main.info = {
                key: '',
                value1: '',
                value2: ''
            };
        }
    }
}





class $80042b03d6bbc1a6$export$2e2bcd8739ae039 extends (0, $5dbb7e23012fa79b$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
        this.started = false;
        this.start = {};
        this.radius = 0;
    }
    mousemove(event) {
        this.main.mouse.x = event._x;
        this.main.mouse.y = event._y;
        this.main.mouse.event = event;
        if (this.started) {
            let dx = this.start.x - (event._x - this.main.netPanningX);
            let dy = this.start.y - (event._y - this.main.netPanningY);
            this.radius = Math.sqrt(dx * dx + dy * dy);
            this.main.tempShape = [
                {
                    start_x: this.start.x,
                    start_y: this.start.y,
                    radius: this.radius,
                    color: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].shapes_fill_temp
                }
            ];
            this.main.info = {
                key: 'Radius: ',
                value1: Math.floor(this.radius),
                value2: ''
            };
        }
    }
    mousedown(event) {
        this.start.x = event._x - this.main.netPanningX;
        this.start.y = event._y - this.main.netPanningY;
        this.started = true;
    }
    mouseup(event) {
        if (this.started) {
            this.started = false;
            this.main.tempShape.length = 0;
            this.main.shapes.push((0, $cfe5df418f7b3b1a$export$c961cccdf4099cd8)({
                start_x: this.start.x,
                start_y: this.start.y,
                radius: 0,
                final_radius: this.radius,
                animationCreate: true,
                counterCreate: 0,
                color: this.main.selectedColorInPanel,
                stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].shapes_stroke
            }));
            this.main.HM.set(this.main.shapes);
            this.radius = 0;
            this.main.info = {
                key: '',
                value1: '',
                value2: ''
            };
        }
    }
}




class $b9f76f46887e61d3$export$2e2bcd8739ae039 extends (0, $5dbb7e23012fa79b$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
        this.started = false;
        this.start = {};
    }
    mousemove(event) {
        this.main.mouse.x = event._x;
        this.main.mouse.y = event._y;
        this.main.mouse.event = event;
        // draw a line when dragging
        if (this.started && (this.main.selected || this.main.selected === 0)) this.main.tempShape = [
            {
                start_x: this.start.x,
                start_y: this.start.y,
                dashed: true,
                end_x: event._x - this.main.netPanningX,
                end_y: event._y - this.main.netPanningY,
                stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].LINES
            }
        ];
    }
    mousedown(event) {
        const pixel = this.main.gctx.getImageData(event._x * this.main.zoomLevel, event._y * this.main.zoomLevel, 1, 1).data;
        // create rgb color for that pixel
        const color = `rgb(${pixel[0]},${pixel[1]},${pixel[2]})`;
        // find a shape with the same colour
        this.main.shapes.forEach((item, index)=>{
            if (item.colorKey === color) {
                item.selected = true;
                this.main.selected = index;
            } else item.selected = false;
        });
        if (this.main.shapes.every((e)=>e.selected === false)) this.main.selected = null;
        else {
            this.started = true;
            this.start.x = event._x - this.main.netPanningX;
            this.start.y = event._y - this.main.netPanningY;
        }
    }
    mouseup(event) {
        if (this.started && (this.main.selected || this.main.selected === 0)) {
            this.started = false;
            this.main.tempShape.length = 0;
            let sel = this.main.shapes[this.main.selected];
            // rect & circle
            if (sel.w || sel.radius) {
                let dx = this.start.x - sel.start_x;
                let dy = this.start.y - sel.start_y;
                sel.new_start_x = event._x - this.main.netPanningX - dx;
                sel.new_start_y = event._y - this.main.netPanningY - dy;
                sel.start_x = this.start.x - dx;
                sel.start_y = this.start.y - dy;
                sel.animationEdit = true;
                sel.counterEdit = 0;
                this.main.HM.set(this.main.shapes);
            } else {
                // lines
                let dx1 = this.start.x - sel.start_x;
                let dy1 = this.start.y - sel.start_y;
                let dx2 = this.start.x - sel.end_x;
                let dy2 = this.start.y - sel.end_y;
                sel.start_x = event._x - this.main.netPanningX - dx1;
                sel.start_y = event._y - this.main.netPanningY - dy1;
                sel.end_x = event._x - this.main.netPanningX - dx2;
                sel.end_y = event._y - this.main.netPanningY - dy2;
                this.main.HM.set(this.main.shapes);
            }
        }
    }
}





class $d6b1bd605d415b8f$export$2e2bcd8739ae039 extends (0, $5dbb7e23012fa79b$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
        this.started = false;
        this.start = {};
    }
    mousemove(event) {
        this.main.mouse.x = event._x;
        this.main.mouse.y = event._y;
        this.main.mouse.event = event;
        // draw a line when dragging
        if (this.started && (this.main.selected || this.main.selected === 0)) this.main.tempShape = [
            {
                start_x: this.start.x,
                start_y: this.start.y,
                dashed: true,
                end_x: event._x - this.main.netPanningX,
                end_y: event._y - this.main.netPanningY,
                stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].LINES
            }
        ];
    }
    mousedown(event) {
        const pixel = this.main.gctx.getImageData(event._x * this.main.zoomLevel, event._y * this.main.zoomLevel, 1, 1).data;
        // create rgb color for that pixel
        const color = `rgb(${pixel[0]},${pixel[1]},${pixel[2]})`;
        // find a shape with the same colour
        this.main.shapes.forEach((item, index)=>{
            if (item.colorKey === color) {
                item.selected = true;
                this.main.selected = index;
            } else item.selected = false;
        });
        if (this.main.shapes.every((e)=>e.selected === false)) this.main.selected = null;
        else {
            this.started = true;
            this.start.x = event._x - this.main.netPanningX;
            this.start.y = event._y - this.main.netPanningY;
        }
    }
    mouseup(event) {
        if (this.started && (this.main.selected || this.main.selected === 0)) {
            this.started = false;
            this.main.tempShape.length = 0;
            let sel = this.main.shapes[this.main.selected];
            // rect & circle
            if (sel.w) {
                let dx = this.start.x - sel.start_x;
                let dy = this.start.y - sel.start_y;
                this.main.shapes.push((0, $cfe5df418f7b3b1a$export$c961cccdf4099cd8)({
                    start_x: this.start.x - dx,
                    start_y: this.start.y - dy,
                    new_start_x: event._x - this.main.netPanningX - dx,
                    new_start_y: event._y - this.main.netPanningY - dy,
                    w: sel.w,
                    h: sel.h,
                    animationEdit: true,
                    counterEdit: 0,
                    color: this.main.selectedColorInPanel,
                    stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].shapes_stroke
                }));
                this.main.HM.set(this.main.shapes);
            } else if (sel.radius) {
                let dx = this.start.x - sel.start_x;
                let dy = this.start.y - sel.start_y;
                this.main.shapes.push((0, $cfe5df418f7b3b1a$export$c961cccdf4099cd8)({
                    start_x: this.start.x - dx,
                    start_y: this.start.y - dy,
                    new_start_x: event._x - this.main.netPanningX - dx,
                    new_start_y: event._y - this.main.netPanningY - dy,
                    radius: sel.radius,
                    animationEdit: true,
                    counterEdit: 0,
                    color: this.main.selectedColorInPanel,
                    stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].shapes_stroke
                }));
                this.main.HM.set(this.main.shapes);
            } else {
                // lines
                let dx1 = this.start.x - sel.start_x;
                let dy1 = this.start.y - sel.start_y;
                let dx2 = this.start.x - sel.end_x;
                let dy2 = this.start.y - sel.end_y;
                this.main.shapes.push((0, $cfe5df418f7b3b1a$export$c961cccdf4099cd8)({
                    start_x: event._x - this.main.netPanningX - dx1,
                    start_y: event._y - this.main.netPanningY - dy1,
                    end_x: event._x - this.main.netPanningX - dx2,
                    end_y: event._y - this.main.netPanningY - dy2,
                    stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].shapes_stroke
                }));
                this.main.HM.set(this.main.shapes);
            }
        }
    }
}




class $466469ee508f1635$export$2e2bcd8739ae039 extends (0, $5dbb7e23012fa79b$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
        this.isResizeDrag = false;
        this.expectResize = -1;
        this.selectionHandles = [
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {}
        ];
        this.mySelColor = '#CC0000';
        this.mySelWidth = 10;
        this.mySelBoxColor = 'darkred'; // New for selection boxes
        this.mySelBoxSize = 10;
    }
    click(e) {
        // get pixel under cursor
        const pixel = this.main.gctx.getImageData(e._x * this.main.zoomLevel, e._y * this.main.zoomLevel, 1, 1).data;
        // create rgb color for that pixel
        const color = `rgb(${pixel[0]},${pixel[1]},${pixel[2]})`;
        // find a shape with the same colour
        this.main.shapes.forEach((item, index)=>{
            if (item.colorKey === color) {
                item.selected = true;
                this.main.selected = index;
            } else item.selected = false;
        });
        if (this.main.shapes.every((e)=>e.selected === false)) this.main.selected = null;
        // if there is a selected and is a rectangle
        if (this.main.selected || this.main.selected === 0) this.createBoxes();
        else this.removeBoxes();
    }
    removeBoxes() {
        this.main.tempShape.length = 0;
        this.selectionHandles = [
            {},
            {},
            {},
            {},
            {},
            {},
            {},
            {}
        ];
    }
    createBoxes() {
        let half = this.mySelBoxSize / 2;
        let choosen = this.main.shapes[this.main.selected];
        // 0  1  2
        // 3     4
        // 5  6  7
        if (choosen.w && choosen.h) {
            // top left, middle, right
            this.selectionHandles[0].x = choosen.start_x - half;
            this.selectionHandles[0].y = choosen.start_y - half;
            this.selectionHandles[1].x = choosen.start_x + choosen.w / 2 - half;
            this.selectionHandles[1].y = choosen.start_y - half;
            this.selectionHandles[2].x = choosen.start_x + choosen.w - half;
            this.selectionHandles[2].y = choosen.start_y - half;
            //middle left
            this.selectionHandles[3].x = choosen.start_x - half;
            this.selectionHandles[3].y = choosen.start_y + choosen.h / 2 - half;
            //middle right
            this.selectionHandles[4].x = choosen.start_x + choosen.w - half;
            this.selectionHandles[4].y = choosen.start_y + choosen.h / 2 - half;
            //bottom left, middle, right
            this.selectionHandles[6].x = choosen.start_x + choosen.w / 2 - half;
            this.selectionHandles[6].y = choosen.start_y + choosen.h - half;
            this.selectionHandles[5].x = choosen.start_x - half;
            this.selectionHandles[5].y = choosen.start_y + choosen.h - half;
            this.selectionHandles[7].x = choosen.start_x + choosen.w - half;
            this.selectionHandles[7].y = choosen.start_y + choosen.h - half;
        } else if (choosen.radius) {
            // top left, middle, right
            this.selectionHandles[0].x = choosen.start_x - choosen.radius - half;
            this.selectionHandles[0].y = choosen.start_y - choosen.radius - half;
            this.selectionHandles[1].x = choosen.start_x - half;
            this.selectionHandles[1].y = choosen.start_y - choosen.radius - half;
            this.selectionHandles[2].x = choosen.start_x + choosen.radius - half;
            this.selectionHandles[2].y = choosen.start_y - choosen.radius - half;
            //middle left
            this.selectionHandles[3].x = choosen.start_x - choosen.radius - half;
            this.selectionHandles[3].y = choosen.start_y - half;
            //middle right
            this.selectionHandles[4].x = choosen.start_x + choosen.radius - half;
            this.selectionHandles[4].y = choosen.start_y - half;
            //bottom left, middle, right
            this.selectionHandles[6].x = choosen.start_x - half;
            this.selectionHandles[6].y = choosen.start_y + choosen.radius - half;
            this.selectionHandles[5].x = choosen.start_x - choosen.radius - half;
            this.selectionHandles[5].y = choosen.start_y + choosen.radius - half;
            this.selectionHandles[7].x = choosen.start_x + choosen.radius - half;
            this.selectionHandles[7].y = choosen.start_y + choosen.radius - half;
        } else {
            this.selectionHandles[0].x = choosen.start_x - half;
            this.selectionHandles[0].y = choosen.start_y - half;
            this.selectionHandles[1].x = choosen.end_x - half;
            this.selectionHandles[1].y = choosen.end_y - half;
        }
        let anchors = [];
        let numberOfAnchors = choosen.end_x ? 2 : 8;
        for(let i = 0; i < numberOfAnchors; i++){
            let ret = this.selectionHandles[i];
            anchors.push({
                start_x: this.selectionHandles[i].x /* - this.main.netPanningX */ ,
                start_y: this.selectionHandles[i].y /* - this.main.netPanningY */ ,
                w: this.mySelWidth,
                h: this.mySelWidth,
                color: this.mySelColor,
                stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].shapes_stroke
            });
        }
        this.main.tempShape = [
            ...anchors
        ];
    }
    mousemove(e) {
        this.main.mouse.x = e._x;
        this.main.mouse.y = e._y;
        this.main.mouse.event = e;
        let mySel = this.main.shapes[this.main.selected];
        let mx = this.main.mouse.x - this.main.netPanningX;
        let my = this.main.mouse.y - this.main.netPanningY;
        if (this.isResizeDrag && mySel) {
            let oldx = mySel.start_x;
            let oldy = mySel.start_y;
            // 0  1  2
            // 3     4
            // 5  6  7
            if (mySel.w && mySel.h) switch(this.expectResize){
                case 0:
                    mySel.start_x = mx;
                    mySel.start_y = my;
                    mySel.w += oldx - mx;
                    mySel.h += oldy - my;
                    break;
                case 1:
                    mySel.start_y = my;
                    mySel.h += oldy - my;
                    break;
                case 2:
                    mySel.start_y = my;
                    mySel.w = mx - oldx;
                    mySel.h += oldy - my;
                    break;
                case 3:
                    mySel.start_x = mx;
                    mySel.w += oldx - mx;
                    break;
                case 4:
                    mySel.w = mx - oldx;
                    break;
                case 5:
                    mySel.start_x = mx;
                    mySel.w += oldx - mx;
                    mySel.h = my - oldy;
                    break;
                case 6:
                    mySel.h = my - oldy;
                    break;
                case 7:
                    mySel.w = mx - oldx;
                    mySel.h = my - oldy;
                    break;
            }
            else if (mySel.radius) {
                // circle resize
                let dx = oldx - mx;
                let dy = oldy - my;
                let dr = Math.sqrt(dx * dx + dy * dy);
                mySel.radius = dr; // updating radius
            } else // edit line
            switch(this.expectResize){
                case 0:
                    mySel.start_x = mx;
                    mySel.start_y = my;
                    break;
                case 1:
                    mySel.end_x = mx;
                    mySel.end_y = my;
                    break;
            }
            this.createBoxes();
        }
        if (mySel !== null && !this.isResizeDrag) {
            for(var i = 0; i < 8; i++){
                // 0  1  2
                // 3     4
                // 5  6  7
                var cur = this.selectionHandles[i];
                // we dont need to use the ghost context because
                // selection handles will always be rectangles
                if (mx >= cur.x && mx <= cur.x + this.mySelBoxSize && my >= cur.y && my <= cur.y + this.mySelBoxSize) {
                    // we found one!
                    this.expectResize = i;
                    if (!mySel.end_x) switch(i){
                        case 0:
                            this.main.canvas.style.cursor = 'nw-resize';
                            break;
                        case 1:
                            this.main.canvas.style.cursor = 'n-resize';
                            break;
                        case 2:
                            this.main.canvas.style.cursor = 'ne-resize';
                            break;
                        case 3:
                            this.main.canvas.style.cursor = 'w-resize';
                            break;
                        case 4:
                            this.main.canvas.style.cursor = 'e-resize';
                            break;
                        case 5:
                            this.main.canvas.style.cursor = 'sw-resize';
                            break;
                        case 6:
                            this.main.canvas.style.cursor = 's-resize';
                            break;
                        case 7:
                            this.main.canvas.style.cursor = 'se-resize';
                            break;
                    }
                    else this.main.canvas.style.cursor = 'all-scroll';
                    return;
                }
            }
            // not over a selection box, return to normal
            this.isResizeDrag = false;
            this.expectResize = -1;
            this.main.canvas.style.cursor = 'auto';
        }
    }
    mousedown(e) {
        // console.log('Command: mousedown', e, this)
        //we are over a selection box
        if (this.expectResize !== -1) {
            this.isResizeDrag = true;
            return;
        }
    }
    mouseup(event) {
        // console.log('Command: mouseup', event, this)
        this.isResizeDrag = false;
        this.expectResize = -1;
        this.main.canvas.style.cursor = "none";
    }
}





class $26c85d6a40888ed9$export$2e2bcd8739ae039 extends (0, $5dbb7e23012fa79b$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
        this.started = false;
        this.start = {};
    }
    mousemove(event) {
        this.main.mouse.x = event._x;
        this.main.mouse.y = event._y;
        this.main.mouse.event = event;
        if (this.started) this.main.tempShape = [
            {
                start_x: this.start.x,
                start_y: this.start.y,
                end_x: event._x - this.main.netPanningX,
                end_y: event._y - this.main.netPanningY,
                stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].LINES
            }
        ];
    }
    mousedown(event) {
        this.start.x = event._x - this.main.netPanningX;
        this.start.y = event._y - this.main.netPanningY;
        this.started = true;
    }
    mouseup(event) {
        if (this.started) {
            this.started = false;
            this.main.tempShape.length = 0;
            this.main.textModal.open(event._x - this.main.netPanningX, event._y - this.main.netPanningY, '', (val)=>this.saveText(val));
        }
    }
    saveText(info) {
        let { x: x, y: y, val: val } = info;
        let dashed_line = (0, $cfe5df418f7b3b1a$export$c961cccdf4099cd8)({
            start_x: this.start.x,
            start_y: this.start.y,
            dashed: true,
            arrowStart: true,
            end_x: x - this.main.netPanningX,
            end_y: y - this.main.netPanningY,
            stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].LINES
        });
        this.main.shapes.push(dashed_line);
        this.main.shapes.push({
            start_x: x - this.main.netPanningX + (0, $3015960e114022d6$export$d597759d33be802e).OFFSET,
            start_y: y - this.main.netPanningY - (0, $3015960e114022d6$export$d597759d33be802e).OFFSET,
            text: val,
            font: (0, $3015960e114022d6$export$d597759d33be802e).FONT,
            fill: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].shapes_stroke,
            colorKey: dashed_line.colorKey
        });
        this.main.HM.set(this.main.shapes);
    }
}





class $b3291d539dca0dfb$export$2e2bcd8739ae039 extends (0, $5dbb7e23012fa79b$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
        this.first = false;
        this.start = {};
        this.d = 0;
    }
    mousemove(event) {
        this.main.mouse.x = event._x;
        this.main.mouse.y = event._y;
        this.main.mouse.event = event;
        if (this.first) {
            this.main.tempShape = [
                {
                    start_x: this.start.x,
                    start_y: this.start.y,
                    dashed: true,
                    end_x: event._x - this.main.netPanningX,
                    end_y: event._y - this.main.netPanningY,
                    stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].LINES
                }
            ];
            let dx = this.start.x - (event._x - this.main.netPanningX);
            let dy = this.start.y - (event._y - this.main.netPanningY);
            this.d = Math.floor(Math.sqrt(dx * dx + dy * dy));
            this.main.info = {
                key: 'Dist: ',
                value1: this.d,
                value2: ''
            };
        }
    }
    mousedown(event) {
        this.start.x = event._x - this.main.netPanningX;
        this.start.y = event._y - this.main.netPanningY;
        this.first = true;
    }
    mouseup(event) {
        if (this.first) {
            this.first = false;
            this.main.tempShape.length = 0;
            let dashed_line = (0, $cfe5df418f7b3b1a$export$c961cccdf4099cd8)({
                start_x: this.start.x,
                start_y: this.start.y,
                // dashed: true,
                arrowStart: true,
                arrowEnd: true,
                end_x: event._x - this.main.netPanningX,
                end_y: event._y - this.main.netPanningY,
                stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].LINES
            });
            this.main.shapes.push(dashed_line);
            var midX = dashed_line.start_x + (dashed_line.end_x - dashed_line.start_x) * 0.50;
            var midY = dashed_line.start_y + (dashed_line.end_y - dashed_line.start_y) * 0.50;
            this.main.shapes.push({
                start_x: midX - this.main.netPanningX,
                start_y: midY - this.main.netPanningY,
                measure: this.d,
                font: (0, $3015960e114022d6$export$d597759d33be802e).FONT,
                fill: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].shapes_stroke,
                colorKey: dashed_line.colorKey
            });
            this.main.HM.set(this.main.shapes);
            this.main.info = {
                key: '',
                value1: '',
                value2: ''
            };
            this.d = 0;
        }
    }
}




class $0cee03d5781acbab$export$2e2bcd8739ae039 extends (0, $5dbb7e23012fa79b$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
        this.started = false;
        this.start = {};
    }
    mousemove(event) {
        this.main.mouse.x = event._x;
        this.main.mouse.y = event._y;
        this.main.mouse.event = event;
        // draw a line when dragging
        if (this.started && (this.main.selected || this.main.selected === 0)) {
            this.main.tempShape = [
                {
                    start_x: this.start.x,
                    start_y: this.start.y,
                    dashed: true,
                    end_x: event._x - this.main.netPanningX,
                    end_y: event._y - this.main.netPanningY,
                    stroke: (0, $3015960e114022d6$export$56d196d2844d1ca1)[this.main.selectedTheme].LINES
                }
            ];
            let dx = event._x - this.main.netPanningX - this.start.x;
            let dy = event._y - this.main.netPanningY - this.start.y;
            let angle = Math.atan2(dy, dx);
            this.main.info = `Angle: ${Math.floor(angle * 180 / Math.PI)}`;
        }
    }
    mousedown(event) {
        const pixel = this.main.gctx.getImageData(event._x * this.main.zoomLevel, event._y * this.main.zoomLevel, 1, 1).data;
        // create rgb color for that pixel
        const color = `rgb(${pixel[0]},${pixel[1]},${pixel[2]})`;
        // find a shape with the same colour
        this.main.shapes.forEach((item, index)=>{
            if (item.colorKey === color) {
                item.selected = true;
                this.main.selected = index;
            } else item.selected = false;
        });
        if (this.main.shapes.every((e)=>e.selected === false)) this.main.selected = null;
        else {
            this.started = true;
            this.start.x = event._x - this.main.netPanningX;
            this.start.y = event._y - this.main.netPanningY;
        }
    }
    mouseup(event) {
        if (this.started && (this.main.selected || this.main.selected === 0)) {
            this.started = false;
            this.main.tempShape.length = 0;
            let sel = this.main.shapes[this.main.selected];
            // rect & circle
            if (sel.w || sel.radius) {
                let dx = event._x - this.main.netPanningX - sel.start_x;
                let dy = event._y - this.main.netPanningY - sel.start_y;
                let angle = Math.atan2(dy, dx);
                // console.log(Math.floor(angle * 180 / Math.PI))
                sel.angle = angle;
                this.main.HM.set(this.main.shapes);
                this.main.info = '';
            }
        }
    }
}


window.onload = ()=>{
    const cad = new $0bfdf291042a0e6e$export$5b410b135eef3881();
    document.getElementById('canvas').replaceWith(cad.canvas);
    cad.start();
    window.cad = cad; // debug
};
class $0bfdf291042a0e6e$export$5b410b135eef3881 {
    constructor(){
        this.canvas = document.getElementById("canvas");
        this.ctx = this.canvas.getContext('2d');
        // ghost canvas for selection
        this.ghostcanvas = document.createElement('canvas');
        this.gctx = this.ghostcanvas.getContext('2d');
        this.keys = new (0, $eb41710cff79e6ba$export$2e2bcd8739ae039)(this);
        this.colorsTable = (0, $cfe5df418f7b3b1a$export$44b25ebaae13a246);
        this.selectedTheme = 'grey'; // white, grey, blue
        this.selectedColorInPanel = '#0074D9';
        this.commands = {
            'SELECT': new (0, $228d9af8d0930561$export$2e2bcd8739ae039)(this),
            'DELETE': new (0, $65d7843234b90f5f$export$2e2bcd8739ae039)(this),
            'COPY': new (0, $d6b1bd605d415b8f$export$2e2bcd8739ae039)(this),
            'MOVE': new (0, $b9f76f46887e61d3$export$2e2bcd8739ae039)(this),
            'RESIZE': new (0, $466469ee508f1635$export$2e2bcd8739ae039)(this),
            'PAN': new (0, $1bf019947b3489fd$export$2e2bcd8739ae039)(this),
            'ZOOM': new (0, $02795c1fd5893706$export$2e2bcd8739ae039)(this),
            'LINE': new (0, $c168e99c8e60108e$export$2e2bcd8739ae039)(this),
            'RECT': new (0, $4b31ddf9131026d9$export$2e2bcd8739ae039)(this),
            'CIRCLE': new (0, $80042b03d6bbc1a6$export$2e2bcd8739ae039)(this),
            'TEXT': new (0, $26c85d6a40888ed9$export$2e2bcd8739ae039)(this),
            'MEASURES': new (0, $b3291d539dca0dfb$export$2e2bcd8739ae039)(this),
            'ROTATE': new (0, $0cee03d5781acbab$export$2e2bcd8739ae039)(this)
        };
        this.textModal = new (0, $da30683a9f099617$export$2e2bcd8739ae039)(this);
        this.panel = new (0, $97e92fc7315ed4d9$export$2e2bcd8739ae039)(this);
        this.mouse = {
            x: 0,
            y: 0,
            event: null
        };
        this.zoomLevel = 1;
        this.choosenUnitSystem = 'ONE';
        this.info = {
            key: '',
            value1: '',
            value2: ''
        }; // what is shown in cursor...
        this.shapes = [];
        this.tempShape = [];
        this.selected = null;
        this.HM = new (0, $24da230c0903dec3$export$2e2bcd8739ae039)(this);
        this.lastTime = new Date().getTime();
        this.currentTime = 0;
        this.delta = 0;
        this.startListening();
        this.resizeCanvas();
    }
    setUnitSystem(what) {
        this.choosenUnitSystem = what;
    }
    getValueAccordingToUnitSystem(val) {
        return val ? val / (0, $3015960e114022d6$export$a037d132965e1c9f)[this.choosenUnitSystem] : '';
    }
    resizeCanvas() {
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
        this.ghostcanvas.width = window.innerWidth;
        this.ghostcanvas.height = window.innerHeight;
        this.canvas.style.cursor = "none";
        this.draw();
    }
    startListening() {
        // resize the canvas to fill browser window dynamically
        window.addEventListener('resize', this.resizeCanvas.bind(this), false);
        this.canvas.oncontextmenu = ()=>false;
        this.canvas.addEventListener('click', this.globalHandler.bind(this), false);
        this.canvas.addEventListener('mousemove', this.globalHandler.bind(this), false);
        this.canvas.addEventListener('mousedown', this.globalHandler.bind(this), false);
        this.canvas.addEventListener('mouseup', this.globalHandler.bind(this), false);
        this.canvas.addEventListener('mouseout', this.globalHandler.bind(this), false);
    }
    globalHandler(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        let x = parseInt(ev.clientX / this.zoomLevel);
        let y = parseInt(ev.clientY / this.zoomLevel);
        /* ----------------- SNAP 2 GRID ----------------- */ if (this.keys.hasSnap && !(this.keys.choosenCommand === 'DELETE' || this.keys.choosenCommand === 'SELECT')) {
            let restoH = x % this.keys.currentSnap;
            if (restoH >= this.keys.currentSnap) x = x - restoH + this.keys.currentSnap;
            else x -= restoH;
            let restoV = y % this.keys.currentSnap;
            if (restoV >= this.keys.currentSnap) y = y - restoV + this.keys.currentSnap;
            else y -= restoV;
        }
        ev._x = x;
        ev._y = y;
        this.currentCommand = this.commands[this.keys.choosenCommand];
        var func = this.currentCommand[ev.type].bind(this.currentCommand);
        if (func) func(ev);
    }
    loop() {
        // time management for animation
        this.currentTime = new Date().getTime();
        this.dt = (this.currentTime - this.lastTime) / 1000;
        this.update(this.dt);
        this.draw();
        this.lastTime = this.currentTime;
        requestAnimationFrame(()=>{
            this.loop();
        });
    }
    start() {
        this.loop();
    }
    unselectAll() {
        this.shapes.forEach((item, index)=>{
            item.selected = false;
        });
        this.selected = null;
    }
    update(dt) {
        // console.log(dt)
        this.HM.value.forEach((item)=>{
            // ANIMATION on COPY / MOVE
            if (item.animationEdit) {
                if (item.counterEdit <= (0, $3015960e114022d6$export$a8fef325e42f6db3).TIME) {
                    item.counterEdit += (0, $3015960e114022d6$export$a8fef325e42f6db3).STEP;
                    let { x: x, y: y } = (0, $cfe5df418f7b3b1a$export$89e29e4ab65e70a9)({
                        x: item.start_x,
                        y: item.start_y
                    }, {
                        x: item.new_start_x,
                        y: item.new_start_y
                    }, item.counterEdit / (0, $3015960e114022d6$export$a8fef325e42f6db3).TIME);
                    item.start_x = x;
                    item.start_y = y;
                } else {
                    item.animationEdit = false;
                    this.unselectAll();
                }
            }
            // Animation on shape creation
            if (item.animationCreate) {
                if (item.counterCreate <= (0, $3015960e114022d6$export$a8fef325e42f6db3).TIME) {
                    item.counterCreate += (0, $3015960e114022d6$export$a8fef325e42f6db3).STEP;
                    // RECT
                    if (item.final_w) {
                        let { x: x, y: y } = (0, $cfe5df418f7b3b1a$export$89e29e4ab65e70a9)({
                            x: item.w,
                            y: item.h
                        }, {
                            x: item.final_w,
                            y: item.final_h
                        }, item.counterCreate / (0, $3015960e114022d6$export$a8fef325e42f6db3).TIME);
                        item.w = x;
                        item.h = y;
                    }
                    // LINE
                    if (item.final_end_x) {
                        let { x: x, y: y } = (0, $cfe5df418f7b3b1a$export$89e29e4ab65e70a9)({
                            x: item.end_x,
                            y: item.end_y
                        }, {
                            x: item.final_end_x,
                            y: item.final_end_y
                        }, item.counterCreate / (0, $3015960e114022d6$export$a8fef325e42f6db3).TIME);
                        item.end_x = x;
                        item.end_y = y;
                    }
                    // CIRCLE
                    if (item.final_radius) {
                        let { x: x } = (0, $cfe5df418f7b3b1a$export$89e29e4ab65e70a9)({
                            x: item.radius,
                            y: 0
                        }, {
                            x: item.final_radius,
                            y: 0
                        }, item.counterCreate / (0, $3015960e114022d6$export$a8fef325e42f6db3).TIME);
                        item.radius = x;
                    }
                } else item.animationCreate = false;
            }
        });
    }
    draw() {
        // CANCAS
        this.ctx.fillStyle = "black";
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.save();
        this.ctx.scale(this.zoomLevel, this.zoomLevel); // apply scale
        this.ctx.translate(this.netPanningX, this.netPanningY); // apply translation
        (0, $34a88fa094de8ae4$export$9556ac62448d043c)(this);
        (0, $34a88fa094de8ae4$export$8a2d2490727d6d12)(this, this.ctx, false);
        (0, $34a88fa094de8ae4$export$f0a6c66fc4a3a14a)(this);
        this.ctx.restore();
        // GHOST CANVAS for HIT Detection
        this.gctx.fillStyle = "black";
        this.gctx.fillRect(0, 0, this.ghostcanvas.width, this.ghostcanvas.height);
        this.gctx.save();
        this.gctx.scale(this.zoomLevel, this.zoomLevel); // apply scale
        this.gctx.translate(this.netPanningX, this.netPanningY); // apply translation
        (0, $34a88fa094de8ae4$export$8a2d2490727d6d12)(this, this.gctx, true);
        this.gctx.restore();
    }
}

})();
//# sourceMappingURL=app.b02a9786.js.map
